export const STATES = [
  {id: 'ACT', title: 'ACT' }, 
  {id: 'QLD', title: 'QLD' }, 
  {id: 'NSW', title: 'NSW' }, 
  {id: 'NT', title: 'NT' }, 
  {id: 'SA', title: 'SA' }, 
  {id: 'TAS', title: 'TAS' }, 
  {id: 'VIC', title: 'VIC' }, 
  {id: 'WA', title: 'WA' }, 
];